import { SET_SERVICE_LIST, SET_ADHOC_SERVICE_LIST } from '../types';

const INITIAL_STATE = {
    list: [],
    adhoc: []
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_SERVICE_LIST:
            return { ...state, list: action.payload }
            case SET_ADHOC_SERVICE_LIST:
            return { ...state, adhoc: action.payload }
        default:
            return state;
    }
}